import React from 'react'
import VisibilitySensor from '@jarvis.oddle/core/components/VisibilitySensor'
import styled from 'styled-components'
import { padding, paddingSizes } from '@jarvis.oddle/core/theme/default'
import breakpoint from 'src/utils/styledComponentsBreakpoint'
import Card from '@jarvis.oddle/core/components/Card'
import { Column } from '@jarvis.oddle/core/components/Grid'
import Skeleton from './Skeleton'

const StyledColumn = styled(Column).attrs(({ listView, showSideNav }) => ({
  sm: listView ? 12 : 6,
  lg: listView ? (showSideNav ? 12 : 6) : showSideNav ? 4 : 3 // 12-based
}))`
  padding: ${padding[paddingSizes.extraSmall]};
  ${breakpoint('desktop')`
    padding: ${padding[paddingSizes.small]};
  `}
`

const StyledSkeleton = styled(Skeleton)`
  height: 100%;
  max-width: 100%;
`

interface ProductCardSkeletonProps {
  listView: boolean
  showSideNav: boolean
  categoryId: string
  showCategoryDetails: (categoryId: string) => void
}

const ProductCardSkeleton = ({
  listView,
  showSideNav,
  categoryId,
  showCategoryDetails
}: ProductCardSkeletonProps): JSX.Element => {
  const onVisibilityChange = React.useCallback(
    (isVisible: boolean) => {
      if (isVisible) {
        showCategoryDetails(categoryId)
      }
    },
    [categoryId, showCategoryDetails]
  )

  return (
    <VisibilitySensor onChange={onVisibilityChange}>
      <StyledColumn listView={listView} showSideNav={showSideNav}>
        <Card height='160'>
          <StyledSkeleton />
        </Card>
      </StyledColumn>
    </VisibilitySensor>
  )
}

export default ProductCardSkeleton
